import LoginMap from '@components/map';
import {
  Alert,
  NewBox as Box,
  Flex,
  Heading,
  Preloader,
  Text,
} from '@retracedgmbh/ui-components-lib';
import { useOrySsoBridge } from '@views/sso-bridge/hooks/useOrySsoBridge';
import { Link, useSearchParams } from 'react-router-dom';

export default function SsoBridge() {
  const [searchParams] = useSearchParams();
  const flowId = searchParams.get('flow');

  const { isError } = useOrySsoBridge(flowId);

  return (
    <section className='hero is-fullheight login-page'>
      <Box className='retraced-light-logo'>
        <img
          src={`${import.meta.env.VITE_CDN_URI}/static/dashboard-service/secondary-logo-cloud-v2.svg`}
          alt='retraced with text'
          width='150'
          loading='lazy'
        />
        <Heading as='h2'>
          Next generation supply chain transparency. At your finger tips.
        </Heading>
      </Box>
      <Box className='hero-body' padding='none'>
        <Box className='columns is-centered' marginX='auto' padding='sm'>
          <Box className='column is-half-tablet is-three-fifths-hd is-centered'>
            <img
              src={`${import.meta.env.VITE_CDN_URI}/static/dashboard-service/secondary-logo-black-v2.svg`}
              className='tw:mb-5 is-hidden-tablet'
              style={{ margin: 'auto' }}
              alt='retraced with text'
              width='150'
              loading='lazy'
            />
          </Box>
          <Box
            className='column is-centered login-container tw:bg-primary-light'
            style={{ minHeight: 400 }}
          >
            {isError && (
              <Alert variant='destructive'>
                Sign in failed. Please try again or contact support.
                <br />
                <Link to='/login'>
                  <Text as='span'>Back to login</Text>
                </Link>
              </Alert>
            )}
            {!isError && (
              <Flex alignItems='center' justify='center'>
                <Preloader loadingText='Signing you in...' />
              </Flex>
            )}
          </Box>
        </Box>
      </Box>

      <Box id='background_image'>
        <LoginMap />
        <img
          alt='Traceability Map'
          id='image0_202_138'
          width='100%'
          height='1734'
          src={`${import.meta.env.VITE_CDN_URI}/static/dashboard-service/map.svg`}
        />
      </Box>
    </section>
  );
}
